import React from "react";
import ActionSlideCard from "./SlideCard";
import { useApiCall } from "~/single-page/hooks/useApiCall";
import ActionManagementsClient from "~/single-page/api/ActionManagementsClient";
import NoItemsMessage from "../NoItemsMessage";
import CustomSlider from '../CustomSlider';

export default function ActionManagementSlider({ ong = null, actions: providedActions = null, showPastStatus = true }) {
  const {
    data: fetchedActions = [],
    success,
    pending,
  } = useApiCall({
    apiCall: () => ong ? ActionManagementsClient.actionManagementsByOng(ong.id) : ActionManagementsClient.actionManagements(),
    init: !providedActions,
    deps: [ong?.id]
  });

  let actions = providedActions || fetchedActions;
  
  if (!providedActions && (!success || !actions.length)) {
    return <NoItemsMessage itemName="ação" gender="feminino" />;
  }

  // Ordenar as ações: futuras primeiro, depois passadas
  if (actions && actions.length > 0) {
    const currentDate = new Date();
    
    // Função para verificar se uma ação já passou
    const isActionPast = (action) => {
      if (action.end_date) {
        return new Date(action.end_date) < currentDate;
      }
      return action.start_date ? new Date(action.start_date) < currentDate : false;
    };
    
    // Ordenar o array de ações
    const sortedActions = [...actions].sort((a, b) => {
      const isPastA = isActionPast(a);
      const isPastB = isActionPast(b);
      
      if (isPastA && !isPastB) {
        return 1; // A está no passado, B no futuro, então B vem primeiro
      }
      if (!isPastA && isPastB) {
        return -1; // A está no futuro, B no passado, então A vem primeiro
      }
      
      // Se ambas estão no futuro ou ambas no passado, ordenar por data
      if (a.start_date && b.start_date) {
        const dateA = new Date(a.start_date);
        const dateB = new Date(b.start_date);
        return isPastA ? dateB - dateA : dateA - dateB;
      }
      
      return 0;
    });
    
    // Atualizar a variável actions com o array ordenado
    actions = sortedActions;
  }

  return (
    <CustomSlider
      items={actions}
      loading={!providedActions && pending}
      renderItem={(action) => {
        const isPastAction = action.end_date
        ? new Date(action.end_date) < new Date()
        : (action.start_date ? new Date(action.start_date) < new Date() : false);
        return (
          <ActionSlideCard 
            action={action} 
            hideOngName={!!ong} 
            isPastAction={isPastAction && showPastStatus}
          />
        );
      }}
    />
  );
}
